export default __webpack_public_path__ + "static/media/watch-complete.1fc502b6.svg";